import RelativePositionComponent from 'Component/Render/RelativePosition';
import SpriteComponent from 'Component/Render/Sprite';
import TextComponent from 'Component/Render/Text';
import TransformComponent from 'Component/Transform';
import { getFieldUnlockShareKey, getHardLevelShareBorder, getHardLevelShareClose } from 'Constants/AvatarsAndCrops';
import Game from 'Game';
import { GameObjectEvent } from 'GameObject/GameObject';
import { HardSharePopupLayout } from 'Layouts/HardSharePopupLayout';
import { ContextType } from 'State/Game/ContextType';
import { GameActions } from 'State/Game/GameActions';
import { PopupID } from 'State/UI/PopupID';
import { ILevelDataFile } from 'System/Level/Data/ILevelDataFile';
import BaseUISystem from 'System/UI/BaseUISystem';
import { applyDefaultButtonAnimation } from 'System/UI/UIHelper';
import { Platform } from 'Utility/Platform';
import Point from 'Utility/Point';
import { WorldDataHelper } from 'Utility/WorldDataHelper';
import BaseMenu from '../BaseMenu';
import { UIActions } from 'State/UI/UIActions';
import LeaderboardHelper from 'System/UI/LeaderboardHelper';

export default class HardSharePopup extends BaseMenu {
    private layout: any;
    private firstComplete: boolean;
    private levelNumber: number;
    private worldNumber: number;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.HARD_LEVEL_SHARE_POPUP, uiSystem, false);
    }

    public onShow(params?: { levelNumber: number; firstComplete: boolean }) {
        this.firstComplete = params.firstComplete;
        this.levelNumber = params.levelNumber;
        this.worldNumber = this.system.store.getState().worldState.worldNumber;

        this.layout = new HardSharePopupLayout();
        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = new Point(0.5, 0.5);
        this.element.addChild(this.layout.root);

        // Background Image
        const fieldData = WorldDataHelper.getFieldByLevelNumber(this.levelNumber, this.worldNumber);
        this.layout.fieldBG.getComponent(SpriteComponent).texture = getFieldUnlockShareKey(fieldData.id);

        //Avatar Image
        const avatarSprite = this.layout.avatar.getComponent(SpriteComponent);
        const avatarTransform = this.layout.avatar.getComponent(TransformComponent);
        LeaderboardHelper.setPlayerAvatar('avatar3', Game.sdk.getAvatar(), avatarSprite, 125);
        avatarTransform.position = new Point(...fieldData.shares.hardShare);

        this.layout.shareText.getComponent(TextComponent).text = Game.locale.getText('Share');
        this.layout.continueText.getComponent(TextComponent).text = Game.locale.getText('Continue');
        this.layout.titleText.getComponent(TextComponent).text = Game.locale.getText('ShareHardLevel');

        this.layout.shareButton.on(GameObjectEvent.SELECTED, this.handleShare);
        this.layout.continueButton.on(GameObjectEvent.SELECTED, this.handleCloseClick);
        this.layout.closeButton.on(GameObjectEvent.SELECTED, this.handleCloseClick);

        [this.layout.shareButton, this.layout.continueButton, this.layout.closeButton].forEach(button =>
            applyDefaultButtonAnimation(button)
        );

        // if (Game.config.platform !== Platform.ANDROID && Game.config.platform !== Platform.IOS) {
        //     this.layout.shareButton.getComponent(SpriteComponent).visible = true;
        // } else {
        //     this.layout.continueButton.getComponent(SpriteComponent).visible = true;
        // }
        this.layout.continueButton.getComponent(SpriteComponent).visible = true;
    }

    public async preload() {
        // if !hardlevel, quit
        const state = Game.store.getState();

        if (!WorldDataHelper.isHardLevel(state.levelState.levelNumber)) return;

        const assets = [];
        assets.push(getHardLevelShareBorder());
        assets.push(getHardLevelShareClose());

        assets.forEach(asset => {
            Game.resource.add(asset.key, asset.path);
        });

        super.preload();
    }

    private readonly handleShare = (): void => {
        GameActions.setContext(ContextType.SHARE_HARD_LEVEL, {
            levelNumber: this.levelNumber,
            worldNumber: this.worldNumber,
            firstComplete: this.firstComplete,
        });
    };

    private readonly handleCloseClick = (): void => {
        UIActions.hidePopup(PopupID.HARD_LEVEL_SHARE_POPUP);
    };
}
